import { GetExpensablesQuery } from 'generated/resources/graphql'

export type Expensable = GetExpensablesQuery['expenses']['expensablesConnection']['nodes'][number]

export type ExpensablePerDiem =
  GetExpensablesQuery['expenses']['expensablesConnection']['nodes'][number]['perDiem']

export const ExpensableRateConfigurationResourceTypeEnum = {
  PerDiem: 'PerDiem',
  Mileage: 'Mileage',
} as const

export type ExpensableRateConfigurationResourceType =
  (typeof ExpensableRateConfigurationResourceTypeEnum)[keyof typeof ExpensableRateConfigurationResourceTypeEnum]
